import React from 'react';

const HeroSection = ({ config, setConfig }) => (
  <div className="bg-white rounded-lg shadow-lg p-6 mb-6" data-testid="hero-section">
    <h2 className="text-xl font-bold mb-4">Hero Section</h2>
    <div className="space-y-4">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">Hero Title</label>
        <input
          type="text"
          data-testid="hero-title-input"
          value={config.hero_title}
          onChange={(e) => setConfig({ ...config, hero_title: e.target.value })}
          className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500"
        />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">Hero Subtitle</label>
        <input
          type="text"
          data-testid="hero-subtitle-input"
          value={config.hero_subtitle}
          onChange={(e) => setConfig({ ...config, hero_subtitle: e.target.value })}
          className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500"
        />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">Hero Description</label>
        <input
          type="text"
          data-testid="hero-description-input"
          value={config.hero_description}
          onChange={(e) => setConfig({ ...config, hero_description: e.target.value })}
          className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500"
        />
      </div>
    </div>
  </div>
);

export default HeroSection;
